import { State } from 'easy-peasy';
import { ErrorEvent, Metadata } from 'mux-embed';
import pkg from '../../package.json';
import { StoreState } from '../store/store';

export type MuxMonitorData = Metadata & {
  custom_content_type?: string;
  custom_entity_id?: string;
  custom_recommendation_id?: string;
};

export function getMuxAssetName(storeState: State<StoreState>): string {
  if (storeState.videos.data) {
    return storeState.videos.data.videoAnalytics.assetName;
  }

  const videoId = storeState.player.videoItem?.guid || storeState.config.videoGuid;
  const videoTitle = videoId ? `[${videoId}] Unknown Title` : 'Unknown Title';

  return storeState.player.videoItem?.title || videoTitle;
}

export function buildMuxMonitorData(storeState: State<StoreState>): MuxMonitorData {
  const [softwareName = 'video.js', softwareVersion = pkg.dependencies['video.js']] = Object.entries(
    storeState.player.videoEngine?.version() || {}
  )[0];
  return {
    env_key: storeState.config.muxEnvKey || undefined,
    video_id: storeState.player.videoItem?.guid || storeState.config.videoGuid || undefined,
    video_title: getMuxAssetName(storeState),
    player_name: storeState.config.muxPlayerName || 'bodi-web',
    player_version: pkg.version,
    player_software_name: softwareName,
    player_software_version: softwareVersion,
    view_client_application_name: storeState.config.appName,
    view_client_application_version: storeState.config.appVersion,
    viewer_user_id: storeState.config.userGuid || undefined,
    custom_content_type: storeState.config.isBODi ? 'BODi' : 'BOD',
    custom_entity_id: storeState.config.entityId || undefined,
    custom_recommendation_id: storeState.config.recommendationId || undefined,
  };
}

export function createMuxErrorTranslator(): (error: ErrorEvent) => ErrorEvent | boolean {
  return (error: ErrorEvent) => {
    if (!error) {
      return false;
    }

    const message = error.player_error_message || 'Unknown player error';
    const prefixedMessage = message.startsWith('[Web Video Player]') ? message : `[Web Video Player] ${message}`;

    return {
      ...error,
      player_error_message: prefixedMessage,
    };
  };
}
